import { LocalStorageKey } from "./LocalStorageKey";

export default class EntityLocalStorageKey extends LocalStorageKey {
  public constructor(entityName: string, identifier: string) {
    super(entityName, identifier);
  }
}
